<template>
    <DashboardTemplate>
      <StartupForm v-if="getRule === 'startup'"/>
      <StaffForm v-if="getRule === 'staff'"/>
      <SpecialAdminForm v-if="getRule === 'specialadmin'"/>
      <AdminForm v-if="getRule === 'admin'"/>
    </DashboardTemplate>
</template>
<script>
import DashboardTemplate from '@/template/DashboardTemplate.vue';
import StartupForm from '@/components/StartupForm.vue';
import SpecialAdminForm from '@/components/SpecialAdminForm.vue';
import AdminForm from '@/components/AdminForm.vue';
import StaffForm from '@/components/StaffForm.vue';

export default {
    components: {
        DashboardTemplate,
        StartupForm,
        SpecialAdminForm,
        AdminForm,
        StaffForm
    },
    computed: {
        getRule() {
            return this.$store.getters.getRule;
        }
    }
}
</script>
<style scoped>

</style>
